import constants from 'common/constants'

import {ONBOARDING_SEED_SAMPLE_DATA} from './ActionTypes/ApiActionTypes'

export const seedOnboardingSampleData = (onSuccess, onFailure) => {
  return {
    type: ONBOARDING_SEED_SAMPLE_DATA,
    payload: {
      apiUrl: constants.api_onboarding_seed_sample_data,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: {},
      onSuccess,
      onFailure,
    },
  }
}
